export function classNameForPaddingForWindowsScrollBars() {
    if(navigator.userAgent.indexOf('Windows NT') > -1) {
        if(navigator.userAgent.indexOf('Edge') > -1) {
            return 'ReactModal--Edge';
        } else {
            return 'ReactModal--Windows';
        }
    } else {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/utils/user-agent-tests.js